export const anchorLinks = (intro) => {

  const anchorLink = '.js-anchor-link';
  let introClicked = false;
  const $page = $([document.documentElement, document.body]);

  let bannerHeight = getComputedStyle(document.documentElement).getPropertyValue("--banner-height-js");
  let bannerTransformValue = getComputedStyle(document.documentElement).getPropertyValue("--banner-transform-js");
  // let minimisedBannerHeight = parseFloat( bannerHeight, 10 ) + parseFloat( bannerTransformValue, 10 ) + "em"
  let minimisedBannerHeight = parseFloat( bannerHeight, 10 ) + parseFloat( bannerTransformValue, 10 );

  // var emMinimisedBannerHeight = Number(getComputedStyle(document.body, "").fontSize.match(/(\d*(\.\d*)?)px/)[1]) * minimisedBannerHeight;
  // var emBannerHeight = Number(getComputedStyle(document.body, "").fontSize.match(/(\d*(\.\d*)?)px/)[1]) * bannerHeight;

  const init = () => {
    bind();
  };

  const bind = () => {

    function scrollToElement(element) {

      $page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
        $page.stop();
      });
      if($('.js-sub-header').length) {
        $page.animate({ scrollTop: $('#'+element).offset().top - bannerHeight - minimisedBannerHeight }, 800, function(){
          $page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
          
          if (!$(this).hasClass("sal-animate")) {
            $page.animate({ scrollTop: $('#'+element).offset().top - bannerHeight - minimisedBannerHeight }, 200, function(){
              $page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
            });
          }
        });
      } else {
        $page.animate({ scrollTop: $('#'+element).offset().top - bannerHeight }, 800, function(){
          $page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
        });
      }

    }

    $(anchorLink).on('click', function(e) {
      e.preventDefault();
      if($(this).hasClass('js-push')) {
        //Intro is clicked. Update variable to make sure the intro scroll animation doesn't run again because of the timeout function
        introClicked = true;
      }
      const element = $(this).data('href');
      scrollToElement(element);
    });

    if ($(intro).length > 0) {
      setTimeout(function(){
        if(introClicked == false && window.scrollY < 200) {
          scrollToElement('main');
        }
      }, 200);
    }

  };

  init();

};
